<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
      button.btn.btn-danger(@click="detachOrderMetadataSchema" v-if="order && order.metadata") Detach metadata schema
    .alert.alert-warning(v-if="noMetadataInfo")
      span Metadata schema not selected. Please go to <router-link :to="{name: 'orderEdit'}">Edit Order</router-link> to select metadata schema.
    Loading(v-if="loading")
    .editor(v-else)
      MetadataEditor(:schema="schema" :metadata="metadata" :disabled="readOnly || saving" @update:data="updateMetadata")
      .text-right.pt20
        SspActionButton(@onClick="save()" :spinning="saving" :disabled="readOnly || !isValid") Save
        a.ml10.btn.btn-default(type="button" @click="$router.go(-1)") Cancel
</template>

<script>
import miniToastr from 'mini-toastr'
import MetadataEditor from '@/components/metadataeditor/MetadataEditor'
import Core from '@/service/apis/Core'
import AuthService from '@/service/AuthService'
import { isEmpty } from '@/utils/lodash'

export default {
  data: () => ({
    metadata: {},
    schema: {},
    saving: false,
    loading: false,
    order: null,
    readOnly: !AuthService.hasRole('ROLE_METADATA_MANAGER'),
    noMetadataInfo: false,
    isValid: false
  }),
  created() {
    this.loadOrder(this.orderId)
  },
  methods: {
    updateMetadata(metadata, isValid) {
      this.metadata = { ...this.metadata, ...metadata }
      this.isValid = isValid
    },
    loadOrder(orderId) {
      this.loading = true
      Core.getOrder(orderId)
        .then((resp) => {
          const order = resp.data
          this.order = resp.data
          if (!order.metadata) {
            this.readOnly = true
            this.noMetadataInfo = true
            return
          }
          this.metadata = order.metadata.data
          if (order.metadata.schema) {
            const schemaId = order.metadata.schema.id
            return Core.getSchemaById(schemaId)
              .then((r) => {
                this.schema = r.data
              })
          }
        })
        .catch((e) => { this.$emit('error', e) })
        .then(() => {
          this.loading = false
        })
    },
    save() {
      this.saving = true
      const { metadata } = this
      Core.saveOrderMetadata(this.orderId, metadata)
        .then(() => {
          miniToastr.success('Order metadata updated successfully')
          this.$router.push({ name: 'order' })
        })
        .catch((e) => { this.$emit('error', e) })
        .then(() => {
          this.saving = false
        })
    },
    detachOrderMetadataSchema() {
      const req = {
        description: this.order.description,
        orderId: this.orderId,
        productId: this.order.productId,
        sectioned: this.order.sectioned,
      }

      if (this.order.metadata && !isEmpty(this.order.metadata.data)) {
        Core.deleteOrderMetadata(this.orderId)
          .then(() => {
            Core.updateOrder(this.orderId, req)
              .then(() => {
                this.$router.push({ name: 'order', params: { id: this.orderId } })
                miniToastr.success('Metadataschema detached')
              })
          })
          .catch((e) => {
            this.$emit('error', e)
          })
      }
    }
  },
  computed: {
    orderId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    MetadataEditor
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/order/OrderMetadata.vue